/**
 * Debug configuration for JelenJS reactive system
 * Uses environment variables for conditional compilation
 */

// Environment-based debug flags that will be replaced during build
declare const __DEV__: boolean;

// Main debug flag - will be replaced by bundler
export const DEBUG_MODE = typeof __DEV__ !== 'undefined' ? __DEV__ : process.env['NODE_ENV'] !== 'production';

// Individual debug flags - can be controlled separately
export const DEBUG_SIGNAL = DEBUG_MODE && (process.env['DEBUG_SIGNAL'] === 'true' || process.env['NODE_ENV'] === 'development');
export const DEBUG_EFFECT = DEBUG_MODE && (process.env['DEBUG_EFFECT'] === 'true' || process.env['NODE_ENV'] === 'development');
export const DEBUG_QUEUE = DEBUG_MODE && (process.env['DEBUG_QUEUE'] === 'true');
export const DEBUG_CONSTANTS = DEBUG_MODE && (process.env['DEBUG_CONSTANTS'] === 'true');

// Debug utility functions that will be completely removed in production
export const debugLog = DEBUG_MODE ? console.log.bind(console) : () => {};
export const debugWarn = DEBUG_MODE ? console.warn.bind(console) : () => {};
export const debugError = DEBUG_MODE ? console.error.bind(console) : () => {};

// Conditional debug wrapper - will be optimized away in production
export function debugSignal(signalId: string, message: string, ...args: any[]): void {
  if (DEBUG_SIGNAL) {
    console.log(`[SIGNAL ${signalId}] ${message}`, ...args);
  }
}

export function debugEffect(effectId: number, message: string, ...args: any[]): void {
  if (DEBUG_EFFECT) {
    console.log(`[EFFECT #${effectId}] ${message}`, ...args);
  }
}

export function debugQueue(message: string, ...args: any[]): void {
  if (DEBUG_QUEUE) {
    console.log(`[QUEUE] ${message}`, ...args);
  }
}

export function debugConstants(message: string, ...args: any[]): void {
  if (DEBUG_CONSTANTS) {
    console.log(`[CONSTANTS] ${message}`, ...args);
  }
} 